import { render, staticRenderFns } from "./epb-divided-layout.component.vue?vue&type=template&id=4b881c02&scoped=true"
import script from "./epb-divided-layout.component.vue?vue&type=script&lang=ts"
export * from "./epb-divided-layout.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-divided-layout.component.vue?vue&type=style&index=0&id=4b881c02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b881c02",
  null
  
)

export default component.exports